import * as actionTypes from '../actions/actionTypes';
import {Map} from 'immutable';
import {ObjectId} from 'bson'

import { ClientWorkflow } from 'schema'

const updateObject = (oldObject, updatedProperties) => {
    return {
        ...oldObject,
        ...updatedProperties
    };
};
const workflowIds = [
    new ObjectId().toString(),
    new ObjectId().toString(),
    new ObjectId().toString(),
    new ObjectId().toString(),
    new ObjectId().toString()
]
// let testWorkflows = {}
// testWorkflows[workflowIds[0]] = new ClientWorkflow({title: 'test', client: 'GoogleCalendar', direction: 'INFLOW', workflowId: workflowIds[0]})
// testWorkflows[workflowIds[1]] = new ClientWorkflow({title: 'test', client: 'GoogleCalendar', direction: 'INFLOW', workflowId: workflowIds[1]})
// testWorkflows[workflowIds[2]] = new ClientWorkflow({title: 'test', client: 'GoogleCalendar', direction: 'INFLOW', workflowId: workflowIds[2]})
// testWorkflows[workflowIds[3]] = new ClientWorkflow({title: 'test', client: 'Telegram', direction: 'OUTFLOW', workflowId: workflowIds[3]})
// testWorkflows[workflowIds[4]] = new ClientWorkflow({title: 'test', client: 'Slack', direction: 'OUTFLOW', workflowId: workflowIds[4]})

const initialState = {
    clients: {},
    workflows: {},
    // workflows: testWorkflows
};

const debug = false
const reducer = ( state = initialState, action ) => {
    switch ( action.type ) {
        /////////////
        // CLIENTS //
        /////////////
        case actionTypes.UPDATE_CLIENTS:
            debug && console.log('[CLIENTS]', action.clients)
            return updateObject(state, { clients: action.clients })

        ////////////////
        // WORKFLOWS //
        ///////////////
        case actionTypes.UPDATE_WORKFLOWS:
            debug && console.log('[CLIENT-WORKFLOWS]', action.workflows)
            return updateObject(state, { workflows: action.workflows })

        default:
            return updateObject(state)
    }
};

export default reducer;
